// Script que remove Vue/Vuex do window após carregamento
// Isso impede detecção pelo Wappalyzer mas mantém funcionalidade interna
(function() {
  // Aguarda carregamento completo do DOM e inicialização do Vue
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cleanup);
  } else {
    cleanup();
  }
  
  function cleanup() {
    // Usa setTimeout para garantir que Vue já foi usado para inicializar componentes
    setTimeout(function() {
      // Remove do window para que Wappalyzer não detecte
      try {
        delete window.Vue;
        delete window.Vuex;
      } catch(e) {
        // Fallback para navegadores antigos
        window.Vue = undefined;
        window.Vuex = undefined;
      }
    }, 100);
  }
})();
